export const TABLE_HEAD_PATIENT_ENGAGEMENT_LIST = [
  { id: 'patientEngagementNumber', label: 'patientEngagement.list.columns.no', align: 'left' },
  { id: 'workflowStatus', label: 'patientEngagement.list.columns.status', align: 'left' },
  { id: 'workflowScope', label: 'patientEngagement.list.columns.scope', align: 'left' },
  { id: 'patientName', label: 'patientEngagement.list.columns.patient', align: 'left' },
  { id: 'workflowOwnedBy', label: 'patientEngagement.list.columns.assignedTo', align: 'left' },
  { id: 'workflowDisposition', label: 'patientEngagement.list.columns.disposition', align: 'left' },
];

export const TABLE_HEAD_PATIENT_ENGAGEMENT_LIST_TABLE = [
  { id: 'careflowIdentifierPatientEngagement', label: 'No.', align: 'left' },
  { id: 'workflowStatus', label: 'Status', align: 'left' },
  { id: 'workflowScope', label: 'Scope', align: 'left' },
  { id: 'contactAttemptContactOn', label: 'Last Contact', align: 'left' },
  { id: 'workflowOwnedBy', label: 'Assigned To', align: 'left' },
  { id: 'workflowDispositionReason', label: 'Disp Reason', align: 'left' },
  { id: 'workflowDispositionOn', label: 'Disp On', align: 'left' },
];

export const TABLE_HEAD_CONTACT = [
  { id: 'when', label: 'When', align: 'center' },
  { id: 'outcome', label: 'Outcome', align: 'left' },
  { id: 'type', label: 'Type', align: 'left' },
  { id: 'nextContact', label: 'Next Contact', align: 'left' },
  { id: 'notes', label: 'Notes', align: 'center' },
];

export const TABLE_HEAD_NOTES = [
  { id: 'text', label: 'Text', align: 'center' },
  { id: 'type', label: 'Type', align: 'left' },
  { id: 'author', label: 'Author', align: 'left' },
  { id: 'date', label: 'Date', align: 'left' },
];
